import { render, staticRenderFns } from "./RtlSupport.vue?vue&type=template&id=622d5aa4"
import script from "./RtlSupport.vue?vue&type=script&lang=js"
export * from "./RtlSupport.vue?vue&type=script&lang=js"
import style0 from "./RtlSupport.vue?vue&type=style&index=0&id=622d5aa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports